export default __webpack_public_path__ + "static/media/desktop.187ff5ce.svg";